import Model from 'flarum/common/Model';

export default class AutomationRule extends Model {
	key() {
		return Model.attribute<string>('key').call(this);
	}

	label() {
		return Model.attribute<string | null>('label').call(this);
	}

	triggerType() {
		return Model.attribute<string>('triggerType').call(this);
	}

	triggerFields() {
		return Model.attribute<any>('triggerFields').call(this) as Array<{
			key: string;
			type: string;
			label: string;
			options?: Record<string, string> | Array<{ value: string; label: string }>;
		}>;
	}
}
